import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { isNativeApp } from './platform';

let identity = {
    kind: 'web',
    version: process.env.VUE_APP_GIT_COMMIT || 'dev',
    build: '',
    model: '',
    manufacturer: '',
};

export function getClientIdentity() {
    return identity;
}

/**
 * Native Store-Version einmal laden, damit der Axios-Interceptor synchron bleiben kann.
 * Web: kind=web, version=Git-Commit.
 */
export async function initClientIdentity() {
    if (!isNativeApp()) {
        return identity;
    }
    try {
        const info = await CapacitorApp.getInfo();
        const platform = Capacitor.getPlatform();
        let kind = 'web';
        if (platform === 'ios') {
            kind = 'ios-app';
        } else if (platform === 'android') {
            kind = 'android-app';
        }
        let model = '';
        let manufacturer = '';
        try {
            const device = await Device.getInfo();
            // model = hw.machine (iPhone17,1) bzw. Build.MODEL — nicht der Gerätename.
            model = device.model ? String(device.model) : '';
            manufacturer = device.manufacturer ? String(device.manufacturer) : '';
        } catch {
            // Modell bleibt leer — UA-Fallback auf dem Server.
        }
        identity = {
            kind,
            version: info.version || '',
            build: info.build ? String(info.build) : '',
            model,
            manufacturer,
        };
    } catch (err) {
        // Interceptor bleibt bei den Defaults — fail-open.
    }
    return identity;
}
